import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../helpers/reducerRegistry'
import {
  getAlertHighlight,
  getCartQuantity,
  getFEComponentAuthorized,
  getPostLoginThunk,
  getUnreadCount,
  getUserType,
} from './thunk'

const initialState = {
  postLogin: undefined,
  userType: {},
  location: {
    prevPath: '',
    currentPath: '',
  },
  cartQuantity: 0,
  alert: {},
  unreadCount: 0,
  reCountNotifications: false,
  componentAuthorized: {},
  isShowScreen: false,
}

export const slice = createSlice({
  name: 'postLoginLayout',
  initialState,
  reducers: {
    changePathName(state, action) {
      state.location = {
        ...state.location,
        ...action.payload,
      }
    },
    changeReCountNotifications: (state, action) => {
      const payload =
        action.payload?.reCountNotifications ?? !state.reCountNotifications
      state.reCountNotifications = payload
    },
    changeIsShowScreen: (state, action) => {
      state.isShowScreen = action.payload
    },
  },
  extraReducers: (builder) => {
    // save post login
    builder.addCase(getPostLoginThunk.fulfilled, (state, action) => {
      state.postLogin = action.payload
    })
    builder.addCase(getUserType.fulfilled, (state, action) => {
      state.userType = action.payload
    })
    //get Cart quantity
    builder.addCase(getCartQuantity.pending, (state) => {
      state.cartQuantity = 0
    })
    builder.addCase(getCartQuantity.fulfilled, (state, action) => {
      state.cartQuantity = action.payload
    })
    builder.addCase(getCartQuantity.rejected, (state) => {
      state.cartQuantity = 0
    })
    //getAlertHightlight
    builder.addCase(getAlertHighlight.fulfilled, (state, action) => {
      state.alert = action.payload || {}
    })
    builder.addCase(getUnreadCount.fulfilled, (state, action) => {
      state.unreadCount = action.payload || 0
    })
    //getFEComponentAuthorized
    builder.addCase(getFEComponentAuthorized.fulfilled, (state, action) => {
      state.componentAuthorized = action.payload
    })
  },
})

export const selectPostLogin = (state) => state[slice.name].postLogin
export const selectUserType = (state) => state[slice.name].userType
export const selectCartQuantity = (state) => state[slice.name].cartQuantity
export const selectPath = (type) => (state) =>
  type ? state[slice.name].location[type] : state[slice.name].location

export const selectAlert = (state) => state[slice.name].alert
export const selectUnreadCount = (state) => state[slice.name].unreadCount
export const selectReCountNotification = (state) =>
  state[slice.name].reCountNotifications
export const selectComponentAuthorized = (state) =>
  state[slice.name].componentAuthorized
export const selectIsShowScreen = (state) => state[slice.name].isShowScreen

export const {
  changePathName,
  changeReCountNotifications,
  changeIsShowScreen,
} = slice.actions

register(slice.name, slice.reducer)
